import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Error from "../../components/404/404";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Logo from "../../images/logo/logo.webp";
import Phone from "../../images/telephone.svg";
import CursorMaus from "../../components/CursorMaus/CursorMaus";
import contacts from "../../api/contacts";

const ErrorPage = () => {
  return (
    <Fragment>
      <Navbar
        Logo={Logo}
        telephone={Phone}
        hclass={"wpo-site-header s1"}
        contact={contacts}
      />
      <Error />
      <Footer contact={contacts} />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};
export default ErrorPage;
